import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Drawer,
  List,
  ListItem,
  ListItemText,
  CssBaseline
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import DropDownImage from "../../assets/Dropdown.png"
import { IoIosHome } from "react-icons/io";
import { BsPersonCircle } from "react-icons/bs";
import { FaBoxOpen } from "react-icons/fa";
import { FaShoppingBag } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { AiFillUnlock } from "react-icons/ai";
import { GiHouseKeys } from "react-icons/gi";

import SearchBar from "material-ui-search-bar";
import Dialog from "../ResetPassword/ResetDialogBox";
import { ToastContainer, toast } from 'react-toastify';

const drawerWidth = 250;

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: '#FFFFFF',
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    })
  },

  appBarShift: {
    backgroundColor: '#FFFFFF',
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  image: {
    marginTop: "1rem",
    marginLeft: "2rem",
  },
  icon: {
    fontSize: "2rem",
    marginRight: "1rem",
    marginTop: "0.5rem",
    color: "#5B6871"
  },
  iconNav: {
    fontSize: "1.5rem",
    marginRight: "1rem",
    marginLeft: "1rem",
    color: "#5B6871"
  },
  iconNav1: {
    fontSize: "1.5rem",
    marginLeft: "1rem",
    color: "#5B6871"
  },

  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    fontFamily: "Ubuntu ,sans-serif",
    color: "#5B6871"
  },
  listCSS: {
    width: drawerWidth,
    marginTop: "0.6rem",

  },
  drawer: {
    backgroundColor: "#F6F8F9",
  },
  content: {
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },

  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: drawerWidth
  },
  SearchBarCSS: {
    width: "65rem",
  }
}));

const HeaderAndLayout = (props) => {
  const history = useHistory();
  function logOut() {
    localStorage.clear();
    history.push('/')
  }
  const classes = useStyles();
  const [opens, setOpens] = useState(false);
  const [open, setOpen] = useState(true);
  const [succesMessage, setSuccesMessage] = useState(false);
  const [failMessage, setFailMessage] = useState(false);
  const [failPasswordMatch, setFailPasswordMatch] = useState(false);

  const notify = () => succesMessage ? toast.success('Action successful!', {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }) : failMessage ? toast.error('Action failed!', {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }) : failPasswordMatch ? toast.error('Passwords do not match!', {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }) : null

  const handleClickOpen = (row) => {
    setOpens(true);
  };

  const handleClose = () => {
    setOpens(false);
  };

  useEffect(() => {
    if (succesMessage) {
      notify();
      setSuccesMessage(false);
    } else {
      if (failMessage) {
        notify();
        setFailMessage(false);
      } else {
        if (failPasswordMatch) {
          notify();
          setFailPasswordMatch(false);
        }
      }
    }
  }, [succesMessage, failMessage, failPasswordMatch]);

  return (
    <div>
      <CssBaseline />
      <Drawer open={open} onClose={() => setOpen(false)} variant="persistent" className={classes.drawer}>
        <img src={DropDownImage} className={classes.image} alt="DropDownImage" width="150" height="40" />
        <List disablePadding className={classes.listCSS}>
          <ListItem disabled={props.activeItem === "dashboard"} button onClick={() => { history.push('/dashboard') }}>
            <IoIosHome className={classes.icon} />
            <ListItemText style={{ color: "#5B6871", fontFamily: 'Ubuntu ,sans-serif', marginTop: '1rem' }} primary="Dashboard" />
          </ListItem>
          <ListItem disabled={props.activeItem === "users"} button onClick={() => { history.push('/users') }}>
            <BsPersonCircle className={classes.icon} />
            <ListItemText style={{ color: "#5B6871", fontFamily: 'Ubuntu ,sans-serif', marginTop: '1rem' }} primary="Users" />
          </ListItem>
          <ListItem disabled={props.activeItem === "listing"} button onClick={() => { history.push('/Listing') }}>
            <FaBoxOpen className={classes.icon} />
            <ListItemText style={{ color: "#5B6871", fontFamily: 'Ubuntu ,sans-serif', marginTop: '1rem' }} primary="Listing" />
          </ListItem>
          <ListItem disabled={props.activeItem === "categories"} button onClick={() => { history.push('/categories') }}>
            <FaShoppingBag className={classes.icon} />
            <ListItemText style={{ color: "#5B6871", fontFamily: 'Ubuntu ,sans-serif', marginTop: '1rem' }} primary="Categories" />
          </ListItem>
        </List>
      </Drawer>
      <AppBar
        className={classNames(classes.appBar, { [classes.appBarShift]: open })}
      >
        <Toolbar style={{ display: "flex", justifyContent: "flex-end" }}>
          <GiHouseKeys className={classes.iconNav1} onClick={() => handleClickOpen()} />
          <FiLogOut className={classes.iconNav1} onClick={logOut} />

        </Toolbar>
        <Dialog
          handleClickOpen={handleClickOpen}
          open={opens}
          handleClose={handleClose}
          setSuccesMessage={setSuccesMessage}
          setFailPasswordMatch={setFailPasswordMatch}
          setFailMessage={setFailMessage}
        />
        <ToastContainer position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHove />
      </AppBar>
    </div>
  )

};
export default HeaderAndLayout;